import { defineMessages } from 'react-intl';

export const nativeEmbedToolbarMessages: {
	alwaysShowTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	expandPreview: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	refresh: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	setEmbedType: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	summarise: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	alwaysShowTitle: {
		id: 'editor-plugin-native-embeds.messages.native-embed-toolbar.alwaysShowTitle',
		defaultMessage: 'Show embed title',
		description:
			'Label for the toggle to enable or disable the behaviour of always showing the title of the embed.',
	},
	expandPreview: {
		id: 'editor-plugin-native-embeds.messages.native-embed-toolbar.expandPreview',
		defaultMessage: 'Expand',
		description: 'Label for the button to expand the embed to fullscreen.',
	},
	refresh: {
		id: 'editor-plugin-native-embeds.messages.native-embed-toolbar.refresh',
		defaultMessage: 'Refresh',
		description: 'Label for the button to refresh the embedded link.',
	},
	setEmbedType: {
		id: 'editor-plugin-native-embeds.messages.native-embed-toolbar.setEmbedType',
		defaultMessage: 'Set embed type',
		description: 'Label for the button to set the type of embed.',
	},
	summarise: {
		id: 'editor-plugin-native-embeds.messages.native-embed-toolbar.summarise',
		defaultMessage: 'Summarize',
		description: 'Label for the button to summarize the content of the embedded link using AI.',
	},
});
